import { of as observableOf } from 'rxjs';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { ADMIN_ROLE } from '@careapp/core';
import { Store } from '@ngrx/store';
import * as actions from '../../store/actions/index';
import { getAuthenticationState } from '../../store/reducers/index';
import { isAppReady } from '../../store/reducers/index';
var GlobalAdminGuard = /** @class */ (function () {
    function GlobalAdminGuard(store) {
        this.store = store;
        this.authenticated = this.store.select(getAuthenticationState);
        this.refreshed = this.store.select(isAppReady);
    }
    GlobalAdminGuard.prototype.canActivate = function () {
        var _this = this;
        return this.refreshed.pipe(filter(function (refreshed) { return refreshed === true; }), withLatestFrom(this.authenticated), switchMap(function (_a) {
            var refreshed = _a[0], auth = _a[1];
            if (auth.auth &&
                auth.auth.id &&
                auth.roles &&
                auth.roles.find(function (role) { return role === ADMIN_ROLE; })) {
                return observableOf(true);
            }
            _this.store.dispatch(actions.NavigateAction({ path: ['/auth'] }));
            return observableOf(false);
        }));
    };
    return GlobalAdminGuard;
}());
export { GlobalAdminGuard };
